import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { buildHttpParams } from 'src/app/helpers/build-state-params';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardDatasourceService {
  private baseUrl = `${environment.v3BaseUrl}/api/v3/admin-desktop`;

  constructor(private http: HttpClient) { }

  getStorageCount(filters: { state?: string[]; groundPositionType?: string[] }) {
    const params = buildHttpParams(filters);
    return this.http.get<{ count: number }>(`${this.baseUrl}/storage/pallets/count`, { params });
  }

  getInOrdersCount(filters: { state?: string[]; entrySource?: string[] }) {
    const params = buildHttpParams(filters);
    return this.http.get<{ count: number }>(`${this.baseUrl}/in-orders/count`, { params });
  }
}
